import styled from "styled-components";
import FacebookIcon from "./SvgIcon/FacebookIcon";
import TwitterIcon from "./SvgIcon/TwitterIcon";
import LinkedInIcon from "./SvgIcon/LinkedInIcon";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";
const Text = styled.h3`
  z-index: 5;
  color: #160647;
  font-family: Gilroy, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
  position: relative;
`;
const Box = styled.div`
  margin-top: 70px;
  width: 100%;
  min-height: 80px;
  padding: 15px 15px 0px 0px;
  display: flex;
  flex-wrap: wrap;
`;
const BoxButton = styled.div`
  display: flex;
  margin-left: auto;
  width: 150px;
  justify-content: space-between;
  @media (max-width: 600px) {
    width: 100%;
    margin-left: 0;
  }
`;
const ShareBox = ({articleUrl}) => {
  return (
    <Box>
      <Text>{"Like what you read? Share with a friend"}</Text>
      <BoxButton>
        <FacebookShareButton url={articleUrl}>
          <FacebookIcon />
        </FacebookShareButton>

        <TwitterShareButton url={articleUrl}>
          <TwitterIcon />
        </TwitterShareButton>
        <LinkedinShareButton url={articleUrl}>
          <LinkedInIcon />
        </LinkedinShareButton>
      </BoxButton>
    </Box>
  );
};
export default ShareBox;
